import { Suspense } from 'react';
import { FormattedMessage } from 'react-intl';

import PlusIcon from '@/assets/icons/plus-sm.svg';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import {
  AddContractProvider,
  useAddContractContext,
} from '@/contexts/add-contract-context';

import { ContractsList } from './contracts-list';
import { ContractForm } from './contract-form';

function ContractsPage() {
  const { setSheetOpen } = useAddContractContext();

  return (
    <div className="mt-4 flex flex-col gap-6">
      <div className="flex items-center justify-between gap-4">
        {/* Title and description */}
        <div className="flex flex-col gap-1">
          <Typography variant="h4" as="h1">
            <FormattedMessage
              defaultMessage="Contracts"
              description="Header for the contracts management section"
            />
          </Typography>
          <Typography variant="body1">
            <FormattedMessage
              defaultMessage="Manage your job board contracts. Active contracts appear as posting options when you post a job, so your team can use them without managing them separately."
              description="Explanation of how active job channel contracts work for the team"
            />
          </Typography>
        </div>

        {/* Button to open create contract modal */}
        <Button
          variant="secondary"
          type="button"
          onClick={() => setSheetOpen(true)}
          className="h-10"
        >
          <img src={PlusIcon} alt="Add" />
          <FormattedMessage
            defaultMessage="Add Contract"
            description="Button to add a new contract"
          />
        </Button>
      </div>

      {/* Grid lists out all vonq contracts */}
      <Suspense fallback={<ContractsList.Skeleton />}>
        <ContractsList />
      </Suspense>

      {/* Modal to create new contract */}
      <ContractForm />
    </div>
  );
}

export function Contracts() {
  return (
    <AddContractProvider>
      <ContractsPage />
    </AddContractProvider>
  );
}
